import type { ICatalog } from '@platform/core/types';
import type { IOrderedSummary } from './IOrderedSummary';

/**
 * Ранг типу запису в порядку прототипу v4 для простору (w.modules — кожен тип окремо; у кожного простору свій порядок): поле `order`
 * каталогу простору, коли сервер його дає; інакше — порядок модулів за `moduleRank` і типів у модулі. Невідомий тип — наприкінці. Чиста функція.
 */
export function recordTypeOrder(catalog: ICatalog | undefined, moduleRank: (key: string) => number): (rtKey: string) => number {
  const rank = new Map<string, number>();
  const types = (catalog?.modules ?? []).flatMap((m) => m.recordTypes.map((r, i) => ({ module: m.key, key: r.key, i, order: (r as IOrderedSummary).order })));
  if (types.some((r) => typeof r.order === 'number')) {
    for (const r of types) rank.set(r.key, typeof r.order === 'number' ? r.order : Number.MAX_SAFE_INTEGER - 1);
  } else {
    [...types].sort((a, b) => moduleRank(a.module) - moduleRank(b.module) || a.module.localeCompare(b.module) || a.i - b.i).forEach((r, n) => rank.set(r.key, n));
  }
  return (rtKey: string) => rank.get(rtKey) ?? Number.MAX_SAFE_INTEGER;
}
